export const REPORT_TIME_INTERVAL = 10000
export const MAX_EVENTLIST_LENGTH = 20
